<template>
  <div>
    <div>
      <Table
        :data="getRoleDetails"
        :stripe="true"
        class="table-striped bordered mt-10"
        aria-describedby="RolePermissionList"
      >
        <table-column :label="$t('MDM_SNO')">
          <template slot-scope="scope">
                <span>
                  {{ scope.row.id }}
                </span>
          </template>
        </table-column>
        <table-column :label="$t('MDM_ROLE')">
          <template slot-scope="scope">
                <span>
                  {{ scope.row.name }}
                </span>
          </template>
        </table-column>
        <table-column >
          <template slot-scope="scope">
            <span class="link-action align-right" @click="openPermissionsPane(scope.row)">
              <svgicon name="edit" width="12" height="12" :original="true"/> {{$t('MDM_EDIT')}}
            </span>
          </template>
        </table-column>
      </Table>
      <Drawer :visible.sync="elDrawerOpen" direction="rtl" size="300px" :modal="true" :withHeader="false"
              :append-to-body="true"  class="default-drawer">
        <Link :underline="false" class="nav-close" @click="closeDrawer">
          <svgicon name="cancelwhite" width="12" height="12" :original="true" />
        </Link>
        <div v-if="!isLoading" class="my-10 overflow-section">
          <div class="p-10  d-flex justify-content-between align-item-center">
            <span class="text-blue-dark1 title py-15 px-30 clearfix">{{selectedRole.name}} Permissions</span>
            <button class="btn btn-primary" :disabled="disabledButton" style="height: 27px" @click="updatePermission" type="button"> {{$t('SAVE')}} </button>
          </div>
          <div class="admin-blog p-0">
            <div class="checkboxgroup" style="overflow-y: auto">
              <div v-for="group in permissionList" :key="group.type">
                <!-- Group Checkbox-->
                <Checkbox
                  class="permission-group"
                  :disabled="group.adminPermission"
                  :indeterminate="isGroupIndeterminate(group)"
                  :value="isGroupChecked(group)"
                  @change="toggleGroup(group)"
                >
                  <div class="group-label" >{{ group.name }}</div>
                </Checkbox>
                <CheckboxGroup class="group-item" v-model="enabledPermissions" @change="checkedChange">
                  <!-- Individual Permissions -->
                  <div class="permission-items">
                    <Checkbox
                      :disabled="group.adminPermission"
                      v-for="(item, index) in group.permissions"
                      :label="item"
                      :key="index"
                    >
                      {{ formatText(item) }}
                    </Checkbox>
                  </div>
              </CheckboxGroup>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RolePermissions',
  data() {
    return {
      roleList: null,
      elDrawerOpen: false,
      hasDataLoaded: false,
      checkAll: false,
      type: '',
      enabledPermissions: [],
      selectedValues: [],
      indeterminate: false,
      selectedRole: '',
      isLoading: false,
      disabledButton: false,
    };
  },
  created() {
  },
  computed: {
    ...mapGetters({
      permissionList: 'profile/permissionList',
      rolePermissions: 'profile/rolePermissions',
    }),
    getRoleDetails() {
      return this.rolePermissions.map((item, index) => ({ ...item, id: index + 1 }));
    },
  },
  methods: {
    closeDrawer() {
      this.elDrawerOpen = false;
    },
    openPermissionsPane(row) {
      this.selectedRole = row;
      const roleType = row.type;
      this.enabledPermissions = this.rolePermissions
        .find(_item => _item.type === roleType).permissions;
      this.hasDataLoaded = true;
      this.checkedChange(this.enabledPermissions);
      this.elDrawerOpen = true;
    },
    checkedChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.permissionList.length;
    },
    isGroupIndeterminate(group) {
      const selected = group.permissions.filter(item => this.enabledPermissions.includes(item));
      return selected.length > 0 && selected.length < group.permissions.length;
    },
    isGroupChecked(group) {
      return group.permissions.every(item => this.enabledPermissions.includes(item));
    },
    toggleGroup(group) {
      const allSelected = this.isGroupChecked(group);
      if (allSelected) {
        // Unselect all permissions of the group
        this.enabledPermissions = this.enabledPermissions
          .filter(item => !group.permissions.includes(item));
      } else {
        // Add missing permissions of the group
        group.permissions.forEach((permission) => {
          if (!this.enabledPermissions.includes(permission)) {
            this.enabledPermissions.push(permission);
          }
        });
      }
    },
    formatText(text) {
      if (!text) return '';
      text = text.replace(/_/g, ' '); // Replace all underscores with space
      return text.charAt(0).toUpperCase() + text.slice(1); // Capitalize first letter
    },
    async updatePermission() {
      this.disabledButton = true;
      const payload = {
        role: this.selectedRole.type,
        permissions: this.enabledPermissions,
      };
      const result = await this.$store.dispatch(
        'profile/updateRolePermission',
        payload,
      );
      this.elDrawerOpen = false;
      this.isLoading = true;
      if (result && result.data === 'Success') {
        this.$successMessage({ message: 'Permission updated successfully' });
        await this.$store.dispatch('profile/getRoles');
      } else {
        this.$errorMessage({ message: result.data.error });
      }
      this.isLoading = false;
      this.disabledButton = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.my-40 {
  margin: 40px 0px;
}

.overflow-section{
  height: calc(100vh - 60px);;
  overflow-y: auto !important;
}

.el-drawer {
  .el-drawer__body{
    overflow-y: auto !important;
  }
}

.align-right{
  text-align: right;
  float: none;
}

.permission-group{
  padding: 5px 20px;
  background-color: #E5E8F2;

  .group-label{
    font-size: 12px;
    font-weight: bold;
  }
}

.group-item{
  padding: 5px 20px;
  margin-bottom: 10px;
}

.title{
  padding: 15px !important;
  font-size: 14px;
  font-weight: bold;
}

button:disabled{
  opacity: .2;
}
</style>
